export class SectionTableFilter {
  valueFrom?: number | Date | string;
  valueTo?: number | Date | string;
  singleValue: number | Date | string;
  filterType: SectionTableFilterTypes;

  static getFilterType(type: number) {
    if (type === 4 || type === 11) {
      return SectionTableFilterTypes.number;
    } else if (type === 2) {
      return SectionTableFilterTypes.date;
    } else if (type === 5) {
      return SectionTableFilterTypes.select;
    } else if (type === 7) {
      return SectionTableFilterTypes.select;
    } else if (type === 1) {
      return SectionTableFilterTypes.string;
    } else if (type === 12) {
      return SectionTableFilterTypes.string;
    } else if (type === 16) {
      return SectionTableFilterTypes.number;
    }
  }
}

export enum SectionTableFilterTypes {
  number = 1,
  date = 2,
  select = 3,
  string = 4,
  fromProperty = 5,
  multiSelect = 6,
  time = 7,
  itemProperties = 8,
  businessPartnerProperties = 9
}
